<template>
  <b-card no-body class="shadow h-100 flex-container grid-stack-item-content flow-window">
    <div slot="header">
      <window-header cmp-title="Bowen stats" widget-name="bowen_stats">

      </window-header>

    </div>
    <div :style="{'flex': 2, 'overflow': 'hidden'}" class="position-relative pl-4 pr-4">
      <div class="row h-100">
        <b-table fixed hover small :items="items" :fields="fields" >

        </b-table>
      </div>

    </div>
  </b-card>

</template>

<script>
  import WindowHeader from './common/WindowHeader'

  export default {
    name: 'BowenStats',
    components: {WindowHeader},
    data () {
      return {
        items: [],
        fields: [
          { key: 'title', label: 'Title', sortable: true },
          { key: 'v', label: 'Value', sortable: true },
          { key: 'cat', label: 'Category', sortable: true }
        ]
      }
    },
    mounted() {
      this.loadStats()
    },
    methods: {
      loadStats () {
        this.$http.get('/api/projects/bowen-stats', {
          params: {
            workpack_id: 12040
          }
        }).then(res => {
          this.items.splice(0, this.items.length)
          this.items.push.apply(this.items, res.body)
        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not load stats data',
            type: 'error'
          })
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BowenStats.vue